import { BehaviorSubject } from "rxjs";
import { map, tap, distinctUntilChanged } from "rxjs/operators";
import { paymentMethods$, fetchPaymentMethods } from "@a365/api";

// Re-exportar el observable original de la API para que esté disponible desde @a365/core
export { paymentMethods$ } from "@a365/api";

// Observable para métodos de pago procesados
export const processedPaymentMethods$ = new BehaviorSubject({
  status: false,
  methods: {},
  installments: {}
});

// Lógica de procesamiento de cuotas
const processInstallments = (data) => {
  // Initialize the result object with existing data
  const result = {
    ...data,
    installments: {
      ...(data.installments || {}),
    },
  }; 

  // Check if Deposit exists in data.installments
  if (data?.methods?.Deposit) {
    result.installments.Deposit = 10
  }

  // Check if Decidir exists in data.installments
  if (data?.installments?.Decidir) {
    let decidir = data.installments.Decidir
      .slice(1, -1)
      .split(",")
    [data.installments.Decidir.slice(1, -1).split(",").length - 1].split(
      ":"
    )[1] || 0;

    // Add Decidir data to result
    result.installments.Decidir = parseInt(decidir);
    result.installments.DecidirRaw = data.installments.Decidir;
  }

  // Check if Dlocal exists in data.installments
  if (data?.installments?.Dlocal) {
    let dlocal = data.installments.Dlocal
      .slice(1, -1)
      .split(",")
    [data.installments.Dlocal.slice(1, -1).split(",").length - 1].split(
      ":"
    )[1] || 0;

    // Add Dlocal data to result
    result.installments.Dlocal = parseInt(dlocal);
    result.installments.DlocalRaw = data.installments.Dlocal;
  }

  return result;
};

// Suscripción para procesar métodos de pago cuando llegan
paymentMethods$.pipe(
  distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
  map(paymentData => {
    if (!paymentData || Object.keys(paymentData).length === 0) {
      return {
        status: false,
        methods: {},
        installments: {}
      };
    }

    // Aplicar lógica de procesamiento de cuotas
    return processInstallments(paymentData);
  })
).subscribe(data => {
  processedPaymentMethods$.next(data);
});

/**
 * Función para cargar métodos de pago
 * @param {string} country_id - ID del país
 */
export const loadPaymentMethods = (country_id) => {
  return fetchPaymentMethods(country_id);
};

// Función de compatibilidad con el código existente
export const getPaymentMethods = loadPaymentMethods;
